import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuGroup,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Link } from "react-router-dom";
import useAuthStore from '@/features/auth/stores/auth.store';
import { Avatar, AvatarFallback } from "@/components/ui/avatar";

export function ProfileMenu() {
  const { user, logout } = useAuthStore();
  
  const getInitials = () => {
    if (!user?.email) return '👤';
    const name = user.full_name || user.email;
    return name.charAt(0).toUpperCase();
  };
  
  const getDisplayName = () => {
    if (user?.full_name) return user.full_name;
    return user?.email.split('@')[0] || 'User';
  };
  
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          className="relative h-10 w-10 rounded-full focus-visible:ring-0 focus-visible:ring-offset-0 hover:bg-transparent"
        >
          <Avatar className="h-10 w-10 bg-primary/10 hover:bg-primary/20 transition-colors">
            <AvatarFallback className="text-lg font-medium text-primary rounded-full">
              {getInitials()}
            </AvatarFallback>
          </Avatar>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-56" align="end">
        <DropdownMenuLabel className="font-normal">
          <div className="flex flex-col space-y-1">
            <p className="text-sm font-medium leading-none">{getDisplayName()}</p>
            <p className="text-xs leading-none text-muted-foreground">{user?.email}</p>
          </div>
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        <DropdownMenuGroup>
          <DropdownMenuItem asChild>
            <Link to="/profile/account-info">Account Info</Link>
          </DropdownMenuItem>
          <DropdownMenuItem asChild>
            <Link to="/profile/settings">Settings</Link>
          </DropdownMenuItem>
          {/* <DropdownMenuItem asChild>
            <Link to="/profile/subscription">Subscription</Link>
          </DropdownMenuItem> */}
        </DropdownMenuGroup>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={logout}>
          Logout
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}

export default ProfileMenu; 